import styled from 'styled-components'

export const PositiveTd = styled.td`
    color: #2a953f;
    font-family: 'Inter';
    font-weight: 400;
    font-size: 1;
`

export const NegativeTd = styled.td`
    color: #b02222;
    font-family: 'Inter';
    font-weight: 400;
    font-size: 1;
`

export const StyledTr = styled.tr`
    tr:not(tr:last-child) {
        border-bottom: 1px solid #d3d3d3;
    }

    > td {
        font-size: 12px;
        color: #333;
        font-family: 'Inter';
        font-weight: 400;

        &.circle {
            span {
                padding: 2px 4px;
                border-radius: 8px;
            }
        }

        &.positive {
            color: #2a953f;
            font-weight: 500;
            span {
            }
        }

        &.negative {
            color: #504f4f;
            font-weight: 500;
            span {
            }
        }

        &.pending {
            color: #504f4f;
            font-weight: 500;
            span {
            }
        }

        &.denied {
            color: #504f4f;
            font-weight: 500;
            span {
            }
        }

        // Situação

        &.small-circle {
            display: flex;
            align-items: center;
        }

        &.confirmed-situation {
            color: #3c934d;
            font-family: 'Poppins';
            font-weight: 500;
        }

        &.settled-situation {
            color: #494980;
            font-family: 'Poppins';
            font-weight: 500;
        }

        &.denied-situation {
            color: #d84b4b;
            font-family: 'Poppins';
            font-weight: 500;
        }

        &.canceled-situation {
            color: #6e7770;
            font-family: 'Poppins';
            font-weight: 500;
        }

        &.pending-situation {
            color: #ba692e;
            font-family: 'Poppins';
            font-weight: 500;
        }

        &.arrow-commission {
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
`
